import { X } from 'phosphor-react';
import React from 'react';
import { Button } from '../../../components/Button';
import Input from '../../../components/Input';
import InputMask from '../../../components/InputMask';
import * as S from './styles';

interface AdminSearchDialogProps {
  crm: string;
  cpf: string;
  nomePaciente: string;
  onCrmChange: (value: string) => void;
  onCpfChange: (value: string) => void;
  onNomePacienteChange: (value: string) => void;
  onClose: () => void;
  onSearch: () => void;
}

export function AdminSearchDialog({
  crm,
  cpf,
  nomePaciente,
  onCrmChange,
  onCpfChange,
  onNomePacienteChange,
  onClose,
  onSearch,
}: AdminSearchDialogProps) {
  const hasCpf = Boolean(cpf.replace(/\D/g, ''));
  const hasNome = Boolean(nomePaciente.trim());
  const hasCrm = Boolean(crm.replace(/\D/g, ''));

  return (
    <S.Container>
      <header>
        <h1>Busca administrativa</h1>
        <X size={24} weight="bold" color="black" onClick={onClose} />
      </header>
      <S.Content>
        <S.Field>
          <p>CRM do médico</p>
          <Input
            type="text"
            placeholder="CRM"
            value={crm}
            disabled={hasCpf}
            onChange={(e) => onCrmChange(e.target.value)}
          />
        </S.Field>
        <S.Field>
          <p>CPF do paciente</p>
          <InputMask
            type="text"
            placeholder="CPF"
            value={cpf}
            disabled={hasCrm || hasNome}
            onChange={(e) => onCpfChange(e.target.value)}
            mask="999.999.999-99"
          />
        </S.Field>
        <S.Field>
          <p>Nome do paciente</p>
          <Input
            type="text"
            placeholder="Nome do paciente"
            value={nomePaciente}
            disabled={hasCpf}
            onChange={(e) => onNomePacienteChange(e.target.value)}
          />
        </S.Field>
        <footer>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={onSearch}>Buscar</Button>
        </footer>
      </S.Content>
    </S.Container>
  );
}
